import { render } from "./EditDelivery.vue?vue&type=template&id=186c686a"
import script from "./EditDelivery.vue?vue&type=script&lang=js"
export * from "./EditDelivery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__